import { Redirect } from "react-router-dom";

// Chakra imports
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Link,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { AuthContext } from "contexts/requiredAuth";
import DefaultAuth from "layouts/auth/variants/Default";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { useState, useContext, useEffect } from "react";
import { maskCpfCnpj } from "config/functions";

//COMPONENTS
import PopOverAlertOrange from "components/popAlert/popAlert";

function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorBrand = useColorModeValue("brand.500", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const [show, setShow] = useState(false);
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [pass, setPass] = useState("");
  const handleClick = () => setShow(!show);
  const { authenticated, login, loading, erroLogin } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const [msgErroLogin, setMsgErroLogin] = useState("");

  useEffect(() => {
    if (erroLogin) {
      setIsOpen(true);
      if (erroLogin == 500) {
        setMsgErroLogin("Erro ao fazer login. Login ou senha inválidos!");
      } else if (erroLogin == 400) {
        setMsgErroLogin("Senha ou login inválidos!");
      } else if (erroLogin == 403 || erroLogin == 401) {
        setMsgErroLogin("Sessão expirada, faça o login novamente!");
      } else {
        setMsgErroLogin("Erro ao fazer login!");
      }

      setTimeout(function () {
        window.location.reload();
      }, 3300);
    }
  }, [authenticated, erroLogin]);

  const handleOpenAlert = (status: boolean) => {
    setIsOpen(status);
  };

  const handleLogin = () => {
    login(cpfCnpj, pass, false);
  };

  const handleInputPass = (event: { target: { value: any } }) => {
    const { value } = event.target;
    setPass(value);
  };

  function handleChangeMask(event: { target: { value: any } }) {
    const { value } = event.target;
    const valueRet = maskCpfCnpj(value);

    setCpfCnpj(valueRet);
  }

  if (!authenticated) {
    return (
      <DefaultAuth
        illustrationBackground={window.config.bannerLogin}
        image={window.config.bannerLogin}
      >
        <Flex
          maxW={{ base: "100%", md: "max-content" }}
          w="100%"
          mx={{ base: "auto", lg: "0px" }}
          me="auto"
          h="100%"
          alignItems="start"
          justifyContent="center"
          mb={{ base: "30px", md: "60px" }}
          px={{ base: "25px", md: "0px" }}
          mt={{ base: "40px", lg: "14vh" }}
          flexDirection="column"
        >
          <PopOverAlertOrange
            handleOpenAlert={handleOpenAlert}
            isOpen={isOpen}
            status="error"
            title="Erro..."
            subtitle={msgErroLogin}
          />
          <Box me="auto">
            <Heading color={textColor} fontSize="36px" mb="10px">
              Entrar
            </Heading>
            <Text
              mb="36px"
              ms="4px"
              color={textColorSecondary}
              fontWeight="400"
              fontSize="md"
            >
              Digite seu CPF e senha para entrar!
            </Text>
          </Box>
          <Flex
            zIndex="2"
            direction="column"
            w={{ base: "100%", md: "420px" }}
            maxW="100%"
            background="transparent"
            borderRadius="15px"
            mx={{ base: "auto", lg: "unset" }}
            me="auto"
            mb={{ base: "20px", md: "auto" }}
          >
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                CPF<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="tel"
                placeholder="000.000.000-00"
                mb="24px"
                fontWeight="500"
                size="lg"
                maxLength={18}
                value={cpfCnpj}
                onChange={handleChangeMask}
              />
              <FormLabel
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                display="flex"
              >
                Senha<Text color={brandStars}>*</Text>
              </FormLabel>
              <InputGroup size="md">
                <Input
                  isRequired={true}
                  fontSize="sm"
                  placeholder="Min. 8 caracteres"
                  mb="24px"
                  size="lg"
                  type={show ? "text" : "password"}
                  variant="auth"
                  onChange={handleInputPass}
                />
                <InputRightElement display="flex" alignItems="center" mt="4px">
                  <Icon
                    color={textColorSecondary}
                    _hover={{ cursor: "pointer" }}
                    as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                    onClick={handleClick}
                  />
                </InputRightElement>
              </InputGroup>
              <Flex justifyContent="space-between" align="center" mb="24px">
                <Link
                  href={
                    window.config.tenant == "Jae"
                      ? `https://app.${window.config.tenant}.com.br/auth/recuperar/atendimento`
                      : window.config.tenant == "Partiu"
                      ? `https://app.partiubilhetagemdigital.com.br/auth/backoffice`
                      : window.config.tenant == "macae"
                      ? `https://app.educamaismacaebeneficios.com.br/auth/backoffice`
                      : `https://app.${window.config.tenant}.com.br/auth/recuperar/atendimento`
                  }
                >
                  <Text
                    color={textColorBrand}
                    fontSize="sm"
                    w="124px"
                    fontWeight="500"
                  >
                    Esqueceu a senha?
                  </Text>
                </Link>
              </Flex>
              <Button
                isLoading={loading}
                loadingText="Entrando..."
                onClick={handleLogin}
                fontSize="sm"
                variant="brand"
                fontWeight="500"
                w="100%"
                h="50"
                mb="24px"
              >
                Entrar
              </Button>
            </FormControl>
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="start"
              maxW="100%"
              mt="0px"
            >
              <Text color={textColorSecondary} fontWeight="400" fontSize="14px">
                Não tem acesso?
                <Link href="mailto:suporte@billingpay.com.br">
                  <Text
                    color={textColorBrand}
                    as="span"
                    ms="5px"
                    fontWeight="700"
                  >
                    Contate o suporte
                  </Text>
                </Link>
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </DefaultAuth>
    );
  } else {
    return <Redirect from="/auth/sign-in/default" to="/admin" />;
  }
}

export default SignIn;
